module.exports = __webpack_public_path__ + "media/images/qr_app_dynamic_download-34c4ea52a878a03656c3ec4e7fa6181b.png";